// External libraries
import { connect } from 'react-redux';

import {
    getEventTitle,
    getEventId,
    getFormattedEventDate,
} from '../../selectors/event';
import { trackProtectedEventsCTAClick } from '../../actions/eventAnalytics';
import { PASSWORD_REQUIRED } from '../../constants';

const _mapStateToProps = (state) => ({
    eventTitle: getEventTitle(state),
    eventDate: getFormattedEventDate(state),
    eventUrl: state.event.url,
    eventId: getEventId(state),
    privacySetting: state.event.privacySetting,
});

const _mapDispatchToProps = (dispatch) => ({
    onCTAClick: (privacySettingType, eventId, eventUrl) => {
        // In the case of Enter Password button we are overriding
        // the href of the button in order to dispatch the
        // tracking event, so we need to manually redirect here
        if (privacySettingType === PASSWORD_REQUIRED) {
            window.open(eventUrl, '_blank');
        }

        dispatch(trackProtectedEventsCTAClick(privacySettingType, eventId));
    },
});

export const connectProtectedEventPage = (ComponentClass) =>
    connect(_mapStateToProps, _mapDispatchToProps)(ComponentClass);
